<template>
	<v-col class="history-transfer">
		<ModalSearch ref="modalSearch" @action="cari"></ModalSearch>
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Downline</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-account-group</v-icon>
			<div class="pl-2">Jaringan</div>
			<div class="px-2">/</div>
			<div>Downline</div>
		</div>
		<div class="mt-5">
			<v-row>
				<v-col cols="6" sm="6" md="6" class="py-0 py-sm-3">
					<v-btn depressed color="primary" class="white--text rounded-lg text-capitalize" v-if="false">
						<v-icon small>mdi-file-excel</v-icon>
						<span class="pl-2">Eksport Excel</span>
					</v-btn>
				</v-col>
				<v-col cols="6" sm="6" md="6" class="py-0 py-sm-3">
					<div class="d-flex justify-end">
						<v-btn depressed color="primary" class="white--text rounded-lg text-capitalize" @click="showSearch">
							<div class="d-flex">
								<v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
								<div class="d-none d-sm-block">Cari</div>
							</div>
						</v-btn>
						<v-btn depressed color="grey lighten-1" class="ml-3 white--text rounded-lg text-capitalize" @click="reset">Reset</v-btn>
					</div>
				</v-col>
			</v-row>
			<div class="mt-3" v-if="!loading">
				<v-row v-if="listDownline.length > 0">
					<v-col cols="12" class="pt-0">
						<v-simple-table class="white-row table-vo table-history-bonus">
							<template v-slot:default>
								<thead class="">
									<tr>
										<th class="text-left font-weight-bold" width="20%">Nama Mitra</th>
										<th class="text-left font-weight-bold">Kode Mitra</th>
										<th class="text-left font-weight-bold" width="20%">Email</th>
										<th class="text-left font-weight-bold">Tanggal Gabung</th>
										<th class="text-left font-weight-bold">Posisi</th>
										<th class="text-center font-weight-bold">Level</th>
									</tr>
								</thead>
								<tbody class="grey--text text--darken-3">
									<tr v-for="downline in listDownline" :key="downline.netgrow_node_id">
										<td class="text-left text-capitalize">{{ downline.member_name }}</td>
										<td class="text-left cl-secondary font-weight-500">{{ downline.network_code }}</td>
										<td class="text-left">{{ downline.member_email }}</td>
										<td class="text-left">{{ downline.netgrow_node_date | tanggal }}</td>
										<td class="text-left">
											<div class="d-flex flex-row align-center">
												<template v-if="downline.netgrow_node_position == 'kiri'">
													<v-icon small color="primary">mdi-arrow-left</v-icon>
													<div class="text-capitalize ml-2">{{ downline.netgrow_node_position }}</div>
												</template>
												<template v-else>
													<div class="text-capitalize mr-2">{{ downline.netgrow_node_position }}</div>
													<v-icon small color="primary">mdi-arrow-right</v-icon>
												</template>
											</div>
										</td>
										<td class="text-center">
											<v-avatar
												color="grey"
												size="32"
											>
												<span class="white--text text-h7 font-weight-bold">{{ downline.netgrow_node_level }}</span>
											</v-avatar>
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>
				</v-row>
				<div class="mt-3" v-if="listDownline.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
								<NoData></NoData>
								<div class="pt-3 text-center cl-secondary">Tidak ada data downline yang dapat ditampilkan</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
				<div v-if="listDownline.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="downlinePagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Menampilkan {{ downlinePagination.total_display }} data dari total {{ downlinePagination.total_data }} data</div>
						</v-col>
						<v-col cols="4" sm="2" md="1">
							<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimit"></v-autocomplete>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="mt-4" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalSearch from './components/ModalSearch';

export default {
	components: {
		ModalSearch
	},
	data() {
		return {
			loading: false,
			transferDate: false,
			dateTransfer: '',
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			params: [],
		}
	},
	computed: {
		...mapState('network', ['listDownline', 'downlinePagination']),
	},
	methods: {
		...mapActions('network', ['getDownline']),

		showSearch() {
			this.$refs.modalSearch.modalShow()
		},
		cari(data) {
			this.params = []
			this.page = 1

			if(data.name.value)
				this.params.push(data.name)

			if(data.code.value)
				this.params.push(data.code)

			if(data.email.value)
				this.params.push(data.email)

			if(data.date.value)
				this.params.push(data.date)

			if(data.level.value)
				this.params.push(data.level)

			this.getDownline(this.queryString({sort: 'member_join_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
				this.$refs.modalSearch.modalHide()
			})
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		reset() {
			this.params = []
			this.page = 1
			this.limit = '10'
			this.getData()
			this.$refs.modalSearch.reset()
		},
		getData() {
			this.loading = true
			this.getDownline(this.queryString({sort: 'member_join_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Downline`)
		this.getData()
	}
};
</script>

